import { render, staticRenderFns } from "./cascader-bdtype.vue?vue&type=template&id=1b6eb61c&"
import script from "./cascader-bdtype.vue?vue&type=script&lang=js&"
export * from "./cascader-bdtype.vue?vue&type=script&lang=js&"
import style0 from "./cascader-bdtype.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports